import React, {useEffect, useRef, useState} from 'react';
import classNames from "classnames";

import './styles.scss';

interface ImageCardProps {
  path: string;
  isRadio?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  selectedIsCorrect?: boolean;
  checkIsDone?: boolean;
}

export const ImageCard: React.FC<ImageCardProps> = ({
  path,
  isRadio = false,
  isSelected,
  onSelect,
  selectedIsCorrect,
  checkIsDone,
}) => {
  const isCorrect = checkIsDone && selectedIsCorrect;

  return (
    <div className={classNames("ImageCard", {
      "isRadio": isRadio,
      "isCorrect": isSelected && checkIsDone && selectedIsCorrect,
      "isIncorrect": checkIsDone && !(isSelected && selectedIsCorrect),
    })}
       onClick={onSelect}
    >
      {isRadio ?
				<label className="ImageLabel">
					<input
						type="radio"
						name="image"
						checked={isSelected}
						onChange={onSelect}
					/>
					<img src={path} alt={path}/>
				</label>
        :
        <img src={path} alt={path}/>
      }
    </div>
  )
};
